'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialOctocat = function IoSocialOctocat(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.4 22.4c0.7 0 1.3 0.3 1.7 1s0.8 1.6 0.8 2.5-0.3 1.8-0.8 2.5-1.1 1-1.7 1c-0.7 0-1.3-0.3-1.8-1s-0.7-1.5-0.7-2.5 0.2-1.8 0.7-2.5c0.5-0.7 1.1-1 1.8-1z m12.3 0c0.7 0 1.2 0.3 1.7 1s0.7 1.6 0.7 2.5-0.2 1.8-0.7 2.5-1 1-1.7 1-1.4-0.3-1.9-1-0.7-1.5-0.7-2.5 0.2-1.8 0.7-2.5c0.5-0.7 1.2-1 1.9-1z m8.6-9c1.9 2.1 2.7 5.2 2.7 7.5 0 1.9-0.1 3.6-0.5 5.1-0.4 1.5-1 2.8-1.6 3.7-0.7 0.9-1.5 1.8-2.5 2.5s-1.9 1.3-2.7 1.6-1.7 0.7-2.8 0.8c-1 0.2-1.9 0.3-2.4 0.3 0 0-2.2 0.1-5 0.1s-5-0.1-5-0.1c-0.5 0-1.4-0.1-2.4-0.3-1.1-0.1-2.1-0.5-2.8-0.8s-1.8-0.9-2.7-1.6c-1-0.7-1.8-1.6-2.5-2.5-0.6-0.9-1.2-2.2-1.6-3.7-0.4-1.5-0.5-3.2-0.5-5.1 0-2.4 0.8-5.4 2.7-7.5 0 0-0.2-1.1 0-3s0.5-3.8 1.2-5.4c2.3 0.2 5.2 1.6 8.8 4 1.1-0.3 2.8-0.5 4.8-0.5 2.2 0 3.7 0.2 4.8 0.5 1.6-1.1 3.1-1.9 4.6-2.6 1.5-0.6 2.6-1 3.2-1.2s1-0.2 1-0.2c0.7 1.6 1.1 3.4 1.2 5.4s0 3 0 3z m-5.1 18.3c2.2-1 3.3-3.1 3.3-6.3 0-1.9-0.7-3.4-2.1-4.6-0.7-0.7-1.5-1-2.5-1.2s-2.4-0.1-4.3 0.1-3.2 0.3-4.1 0.3-2-0.2-3.3-0.2-2.3-0.3-3-0.3c-0.8 0-1.6 0-2.4 0.2s-1.7 0.5-2.2 1.1c-1.4 1.2-2 2.7-2 4.6 0 3.2 1 5.3 3.2 6.3 2.1 1 5.4 1.4 9.6 1.4h0.2c4.2 0 7.4-0.4 9.6-1.4z' })
        )
    );
};

exports.default = IoSocialOctocat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-octocat.js
// module id = 2695
// module chunks = 0